import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Phone, Video, X } from "lucide-react";
import { toast } from "sonner";
import { Avatar } from "@/components/common";
import { api, apiError } from "@/lib/api";

export const CallButton = ({ member, compact = false, voice = false }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setBusy(true);
    try { const { data } = await api.post("/calls", { user_id: member.id, voice }); navigate(`/call/${data.call_id}`, { state: data }); }
    catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  return (
    <button type="button" className={compact ? "btn-outline h-10 px-4 text-sm" : "btn-outline"} disabled={busy} onClick={start}
      aria-label={`${voice ? "Voice" : "Video"} call ${member.name}`} data-testid={`${voice ? "voice" : "video"}-call-${member.id}`}>
      {voice ? <Phone className="h-4 w-4" /> : <Video className="h-4 w-4" />}{!compact && (voice ? " Voice call" : " Video call")}</button>
  );
};

export const IncomingCall = () => {
  const navigate = useNavigate();
  const [call, setCall] = useState(null);
  const [dismissed, setDismissed] = useState("");
  useEffect(() => {
    const poll = () => api.get("/calls/incoming").then(({ data }) => setCall(data.call)).catch(() => {});
    poll();
    const t = setInterval(poll, 8000);
    return () => clearInterval(t);
  }, []);
  if (!call || dismissed === call.call_id || window.location.pathname.startsWith("/call/")) return null;
  return (
    <div role="alertdialog" aria-label="Incoming video call" className="fixed inset-x-4 bottom-24 z-50 mx-auto flex max-w-md items-center gap-3 rounded-xl border border-primary/50 bg-card p-4 shadow-2xl lg:bottom-6" data-testid="incoming-call">
      <Avatar person={call.caller} size={48} />
      <p className="min-w-0 flex-1 text-sm"><span className="font-semibold">{call.caller.name}</span> is {call.voice ? "voice" : "video"} calling you</p>
      <button type="button" className="btn-primary h-10 px-4 text-sm" onClick={() => { setDismissed(call.call_id); navigate(`/call/${call.call_id}`); }} data-testid="incoming-call-join"><Phone className="h-4 w-4" /> Join</button>
      <button type="button" className="btn-outline h-10 w-10 px-0" aria-label="Dismiss call" onClick={() => setDismissed(call.call_id)} data-testid="incoming-call-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
};

let availability;
export const useCallsAvailable = () => {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    availability = availability || api.get("/calls/availability").then(({ data }) => data.available).catch(() => { availability = null; return false; });
    availability.then(setOk);
  }, []);
  return ok;
};

